// removed by extract-text-webpack-plugin
module.exports = {"icon":"Icon-icon-28569eab","icon-small":"Icon-icon-small-3df7622e","iconSmall":"Icon-icon-small-3df7622e","icon-default":"Icon-icon-default-ee01cc8e","iconDefault":"Icon-icon-default-ee01cc8e","icon-medium":"Icon-icon-medium-9f7fdac8","iconMedium":"Icon-icon-medium-9f7fdac8","icon-large":"Icon-icon-large-560ad027","iconLarge":"Icon-icon-large-560ad027","auto-height":"Icon-auto-height-49a60b5f","autoHeight":"Icon-auto-height-49a60b5f"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/Icon.scss
// module id = 601
// module chunks = 0